// import { Badge } from "@material-ui/core";
import React from "react";
import { Container } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import CounterCard from "../../Molecules/Card/CounterCard/CounterCard";
import SelectCard from "../../Molecules/Card/SelectCard/SelectCard";
import * as Constants from "../../../constants";
import { verifyStatus } from "../../../helpers/customizedItem/customizedItem.helper";
import { IParams } from "../../../models/card";
import { ICoreModifiers } from "../../../models/item.model";
import { ICoreModifiersComponent } from "../../../models/try2Combo";


const CoreModifiers: React.FC<ICoreModifiersComponent> = (props) => {
  const {
    coreModifiers,
    selectedCore,
    handleCoreModifierClick,
    isLimitExceed,
  } = props;

  const selectedCoreModifier = (modifier) => {
    return selectedCore.find(
      (selected) => selected.modifier_id === modifier.id
    );
  };

  const handleIngredientSelection = (data:IParams,modifier:ICoreModifiers) => {
      handleCoreModifierClick(
        {
          ...data,
          ...{
            brink_modifier_group_id:
              modifier?.brink_modifier_group_id,
            brink_modifier_id:
              modifier?.brink_modifier_id,
            core: true,
          },
        },
        modifier,
        Constants.CORE_MODIFIERS
      )
  }

  return (
    <React.Fragment>
      {coreModifiers?.length > 0 &&
        <Container fluid className="px-0">
          <Accordion
            defaultActiveKey={["1"]}
            alwaysOpen
            className="theme-custom-accordions item-customization-acc "
          >
            <Accordion.Item eventKey="0">
              <Accordion.Header>Included Ingredients</Accordion.Header>
              <Accordion.Body>
                <div className="single-item-modifiers">
                  {coreModifiers &&
                    coreModifiers.map((modifier) => {
                      const selected = selectedCoreModifier(modifier);
                      return (

                        <div key={modifier?.id} className="item__modifier_item">
                          {modifier?.max > 1 ? (
                            <CounterCard
                              id={modifier?.id}
                              brink_id={modifier?.brink_modifier_id}
                              image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier?.image}`}
                              title={modifier.name}
                              price={modifier.price}
                              calories={modifier.calories}
                              max={modifier.max}
                              groupMin={modifier.modifier_group_min}
                              is_active={verifyStatus(
                                modifier,
                                Constants.MODIFIER_LOCATION
                              )}
                              handleClick={(data) => handleIngredientSelection(data,modifier)}
                              count={selected?.quantity || 0}
                              from={Constants.TRY_2_COMBO}
                              priceAlternateLabel={
                                selected?.quantity ? "included" : "include"
                              }
                              modifierType={"core_modifier"}
                              additionalPrice={selected?.additionalPrice}
                              extendableLimit={isLimitExceed(
                                modifier?.modifier_group_id,
                                modifier?.modifier_group_extendable_limit,
                                modifier.modifier_group_min
                              )}
                              extendableLimitValue={
                                modifier?.modifier_group_extendable_limit
                              }
                            />
                          ) : (
                            <SelectCard
                              id={modifier?.id}
                              brink_id={modifier?.brink_modifier_id}
                              default_selected={
                                modifier.is_selected ? modifier.is_selected : 1
                              }
                              image={`${Constants.REACT_APP_CLOUD_FRONT}${modifier.image}`}
                              title={modifier.name}
                              price={modifier.price}
                              calories={modifier.calories}
                              groupMin={modifier.modifier_group_min}
                              is_active={verifyStatus(
                                modifier,
                                Constants.MODIFIER_LOCATION
                              )}
                              handleClick={(data) => handleIngredientSelection(data,modifier)}
                              priceAlternateLabel={
                                selected?.quantity ? "included" : "include"
                              }
                              selected={Boolean(selected)}
                              modifierAdditionalPrice={selected?.additionalPrice}
                              componentUsedIn={Constants.TRY_2_COMBO}
                              extendableLimit={isLimitExceed(
                                modifier?.modifier_group_id,
                                modifier?.modifier_group_extendable_limit,
                                modifier.modifier_group_min
                              )}
                              extendableLimitValue={
                                modifier?.modifier_group_extendable_limit
                              }
                            />
                          )}
                        </div>
                      );
                    })}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Container>
      }
    </React.Fragment>
  );
};

export default CoreModifiers;
